module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white upload-screen-1-container"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "hr-text"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "img-and-caption-container",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "img-container",
    attrs: {
      "xs4": "",
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/viewzzz/image/upload/w_auto/v1523306017/dpfvh28om5ef75hlbdtc.jpg"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption-container",
    attrs: {
      "xs8": "",
      "md11": ""
    }
  }, [_vm._v("\n      The more relevant tags you add to this photo, the more people will discover it.\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "tags-container",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-headline text-xs-left"
  }, [_vm._v("\n       Tags: Selected\n     ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "tag-btn-container text-xs-right"
  }, [_c('v-btn', {
    staticClass: "cyan white--text",
    staticStyle: {
      "margin": "0",
      "font-size": "11px"
    },
    attrs: {
      "round": "",
      "small": ""
    }
  }, [_vm._v("Add new")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tags-chip-container text-xs-left",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.selectedTags), function(chip, chipIndex) {
    return _c('div', {
      key: chipIndex,
      staticStyle: {
        "position": "relative"
      }
    }, [_c('v-icon', {
      staticStyle: {
        "position": "absolute",
        "top": "7px",
        "right": "13px",
        "font-size": "18px"
      },
      on: {
        "click": function($event) {
          return _vm.selectedTags.splice(chipIndex, 1)
        }
      }
    }, [_vm._v("\n        clear\n      ")]), _vm._v(" "), _c('v-chip', {
      staticClass: "blue black--text",
      staticStyle: {
        "width": "95px",
        "font-size": "12px"
      },
      attrs: {
        "outline": "",
        "label": "",
        "small": ""
      }
    }, [_vm._v("\n        " + _vm._s(chip) + "\n      ")])], 1)
  }), 0), _vm._v(" "), _c('v-layout', {
    staticClass: "tags-container mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticClass: "tag-headline text-xs-left"
  }, [_vm._v("\n      Suggested\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-left"
  }, _vm._l((_vm.suggestions), function(suggestionText) {
    return _c('button', {
      staticClass: "suggestion-btn",
      on: {
        "click": function($event) {
          return _vm.selectedTags.push(suggestionText)
        }
      }
    }, [_vm._v("\n      " + _vm._s(suggestionText) + "\n    ")])
  }), 0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "important-details-container"
  }, [_c('div', {
    staticClass: "important-details"
  }, [_vm._v("Make it popular")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fee44d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadScreens/uploadScreen-2.vue
// module id = 829
// module chunks = 0